__webpack_require__.p = "/static/ws/inv-text-search/";